import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from './store';

interface GasLimitInfo {
  newAddressGasLimit: string;
  oldAddressGasLimit: string;
  withdrawalGasLimit: string;
}

interface AddressInfo {
  name: string;
  decimals: number;
  gasLimit?: GasLimitInfo;
}

export interface AssetInfos {
  [chainName: string]: {
    [address: string]: AddressInfo;
  };
}

interface InitState {
  list: AssetInfos;
}

const initialState: InitState = { list: {} };

export const assetInfoSlice = createSlice({
  name: 'assetInfoSlice',
  initialState,
  reducers: {
    setAssetInfoList: (state, action: PayloadAction<AssetInfos>) => {
      state.list = action.payload;
    },
  },
});

export const { setAssetInfoList } = assetInfoSlice.actions;

export const selectAssetInfos = (state: RootState) => state.assetInfos;
export default assetInfoSlice.reducer;
